import RestAPI from '../../../Common/restApi';
import { ERROR_TEXT } from '../../../Setup/Redux/Actions';
import { latestMuiTheme } from '../../../ProThemeNext.js.jsx';
import AppDetailsApi from '../AppDetailsApi.js';
import { getIntialServiceAgreementState } from '../Models/ServiceAgreementsModel';
import * as ActionTypes from './ActionTypes';
import { TOGGLE_PAYWALL_DIALOG_OPEN } from 'components/PayWall/Redux/Actions';
import RedirectTo from '../../../Common/RedirectTo';
import { receivedServerData } from '../../../Common/Data/DataFetcher';
import AppsApi from '../../../../Resources/Organization/Apps/AppsApi';
import { getAppStatus as getAppStatusFromEntities } from '../../../../Resources/Organization/Apps/AppsData';
import WisetackApi from '../Api/WisetackApi';
import Utils from '../../../Common/Utils';
import { ENTITY_APPS } from '../../../../Schema/Apps';
import { updateEntity } from '../../../Common/Data/DataFetcherEntitiesHelper';
import { DISPATCH, STATE_ENABLED, STATE_PENDING, STATE_DISABLED } from '../AppsData.js';
import { trackButtonClicked } from '../../../Services/Analytics/TrackEventsService.js';

export const SHOW_GOOGLE_DISCONNECT_CAL_DIALOG = 'SHOW_GOOGLE_DISCONNECT_CAL_DIALOG';
export const SHOW_IMPORT_CONFIRMATION_DIALOG = 'SHOW_IMPORT_CONFIRMATION_DIALOG';
export const SHOW_QBO_INTEGRATION_CARD_SPINNER = 'SHOW_QBO_INTEGRATION_CARD_SPINNER';
export const QBO_ACCOUNT_INFO = 'QBO_ACCOUNT_INFO';
const BUTTON_TEXT_ACTIVE = 'active';
const BUTTON_TEXT_DISABLED = 'disabled';

export function setInitialAppState(data) {
  let googleReviewsStatus = '';
  let googlePlaceID = '';

  if (data.settings && data.settings.google_reviews_config) {
    googleReviewsStatus = data.settings.google_reviews_config.status;
    googlePlaceID = data.settings.google_reviews_config.google_place_id;

    data.settings.google_reviews_config = undefined;
  }

  return {
    type: ActionTypes.SET_INITIAL_APP_STATE,
    canUseApp: data.can_use_feature,
    appEnabled: data.is_enabled,
    plansRequired: data.payment_plans_required,
    buttonText: data.is_enabled ? BUTTON_TEXT_ACTIVE : BUTTON_TEXT_DISABLED,
    buttonColor: data.is_enabled ? latestMuiTheme.palette.secondary[500] : latestMuiTheme.palette.secondaryTextColor,
    appConfiguration: data?.configuration ?? {},
    settings: {
      ...data.settings,
      googleReviewsStatus,
      googlePlaceID,
    },
  };
}

export function updateAppConfiguration(config) {
  return {
    type: ActionTypes.UPDATE_APP_CONFIGURATION,
    configuration: config,
  };
}

export function setAppEnabled() {
  return {
    type: ActionTypes.UPDATE_APP_STATE,
    buttonColor: latestMuiTheme.palette.secondary[500],
    buttonText: BUTTON_TEXT_ACTIVE,
    appEnabled: true,
  };
}

export function setAppDisabled() {
  return {
    type: ActionTypes.UPDATE_APP_STATE,
    buttonColor: latestMuiTheme.palette.secondaryTextColor,
    buttonText: BUTTON_TEXT_DISABLED,
    appEnabled: false,
  };
}

export function openAppEnabledDialog() {
  return { type: ActionTypes.SET_ENABLED_DIALOG_STATUS, status: true };
}

export function openReviewsAppEnabledDialog() {
  return { type: ActionTypes.SET_REVIEWS_ENABLED_DIALOG_STATUS, status: true };
}

export function showGoogleCalDisconnectDialog(show) {
  return { type: SHOW_GOOGLE_DISCONNECT_CAL_DIALOG, status: show };
}

export function openPaywall() {
  return (dispatch, getState) =>
    dispatch({ type: TOGGLE_PAYWALL_DIALOG_OPEN, status: true, required: getState().plansRequired[0] });
}

export function getServiceAgreementInitialData() {
  return (dispatch) => {
    getIntialServiceAgreementState().then((response) => {
      dispatch(setInitialAppState(response.data));
    });
  };
}

export function disconnectGoogleCalendar(callback) {
  return (dispatch) =>
    AppDetailsApi.disconnectGoogleCalendar()
      .then((response) => {
        RedirectTo.appsDetails('gcal');
      })
      .catch((error) => {
        dispatch({ type: ERROR_TEXT, errorText: error.response.data.error });
        callback();
      });
}

export function getApplicationUrl() {
  return (dispatch) => {
    WisetackApi.show()
      .then((response) => {
        window.open(response.data, '_blank');
      })
      .catch((error) => {
        dispatch({ type: ERROR_TEXT, errorText: error.response.data.error });
      });
  };
}

// ------------------------------------------------------------------------------

export function toggleEnabled(app, showEnabledDialog = true) {
  return (dispatch, getState) => {
    const state = getState();
    const newEnabledValue = !state.appEnabled;
    let newState = newEnabledValue ? STATE_ENABLED : STATE_DISABLED;
    let updateValues = { enabled: newEnabledValue, state: newState };

    if (state.canUseApp) {
      return AppsApi.updateApp(app, updateValues)
        .then((response) => {
          if (newEnabledValue) {
            if (showEnabledDialog) {
              dispatch(openAppEnabledDialog());
            }
            dispatch(setAppEnabled());
          } else {
            dispatch(setAppDisabled());
          }
        })
        .catch((error) => {
          dispatch(setAppDisabled());
        });
    } else {
      return dispatch(openPaywall());
    }
  };
}

export function toggleEnabledWithEntity(app) {
  return (dispatch, getState) => {
    const appStatusCopy = { ...getAppStatusFromEntities(app)(getState()) };
    const newEnabledValue = !appStatusCopy.is_enabled;
    let newState = newEnabledValue ? STATE_ENABLED : STATE_DISABLED;
    let updateValues = { enabled: newEnabledValue };

    if (app === DISPATCH) {
      newState = newEnabledValue ? STATE_PENDING : STATE_DISABLED;
    }
    updateValues = { ...updateValues, state: newState };

    dispatch(trackButtonClicked(newEnabledValue ? 'App enabled' : 'App disabled', { app_name: app }));

    return AppsApi.updateApp(app, updateValues)
      .then(() => {
        if (newEnabledValue) {
          dispatch(setAppEnabled());
        } else {
          dispatch(setAppDisabled());
        }

        appStatusCopy.is_enabled = newEnabledValue;
        appStatusCopy.state = newState;
        dispatch(updateEntity(app, { status: appStatusCopy }, ENTITY_APPS));
      })
      .catch((error) => {
        dispatch({ type: ERROR_TEXT, errorText: Utils.parseErrorMessage(error) });
      });
  };
}
